import type { AppRouteModule } from '/@/router/types';

const bigScreenRoutes: AppRouteModule[] = [
  {
    path: '/op/big-screen',
    name: 'Op-Big-Screen',
    component: () => import('/@/views/op/big-screen/index.vue'),
    meta: {
      title: '设备大屏',
      ignoreAuth: true,
      hideMenu: true,
      hideBreadcrumb: true,
    },
  },
  {
    path: '/op/mns',
    name: 'Op-MNS-Screen',
    component: () => import('/@/views/op/big-screen/mns.vue'),
    meta: {
      title: '设备大屏',
      ignoreAuth: true,
      hideMenu: true,
      hideBreadcrumb: true,
    },
  },
  {
    path: '/op/bky',
    name: 'Op-Bky-Screen',
    component: () => import('/@/views/op/big-screen/Bky.vue'),
    meta: {
      title: '设备大屏',
      ignoreAuth: true,
      hideMenu: true,
      hideBreadcrumb: true,
    },
  },
  {
    path: '/op/wht',
    name: 'Op-Wht-Screen',
    component: () => import('/@/views/op/big-screen/WholeHouseTrace.vue'),
    meta: {
      title: '设备大屏',
      ignoreAuth: true,
      hideMenu: true,
      hideBreadcrumb: true,
    },
  },
  {
    path: '/op/screen',
    name: 'Op-Normal-Screen',
    component: () => import('/@/views/op/big-screen/Screen.vue'),
    meta: {
      title: '设备大屏',
      ignoreAuth: true,
      hideMenu: true,
      hideBreadcrumb: true,
    },
  },
  {
    path: '/op/radar-dashboard',
    name: 'Op-Radar-Dashboard',
    component: () => import('/@/views/op/big-screen/radar-dashboard/index.vue'),
    meta: {
      title: '设备大屏',
      ignoreAuth: true,
      hideMenu: true,
      hideBreadcrumb: true,
    },
  },
  {
    path: '/op/radar-dashboard-test',
    name: 'Op-Radar-Dashboard-Test',
    component: () => import('/@/views/op/big-screen/radar-dashboard-test/index.vue'),
    meta: {
      title: '设备大屏',
      ignoreAuth: true,
      hideMenu: true,
      hideBreadcrumb: true,
    },
  },
  {
    path: '/op/floor-plan',
    name: 'Op-Floor-Plan',
    component: () => import('/@/views/op/big-screen/floor-plan/index.vue'),
    meta: {
      title: '户型图',
      ignoreAuth: true,
      hideMenu: true,
      hideBreadcrumb: true,
    },
  },
];

export default bigScreenRoutes;
